import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MessageService } from 'primeng/api';
import { DocumentLibraryConstants } from '../../document-library-constants';
import { DocumentPhaseChange } from '../../models/documentPhaseChange';
import { DocumentService } from '../../services/document.service';

@Component({
  selector: 'app-deactivate-button',
  templateUrl: './deactivate-button.component.html',
  styleUrls: ['./deactivate-button.component.scss']
})
export class DeactivateButtonComponent implements OnInit {
deactivateButton !: DocumentPhaseChange;
@Output() isDeactivationModalVisible = new EventEmitter<boolean>();
display: boolean = false;
@Input() documentNumber!: string;
@Input() documentVersion!: string;
reason: string = '';
mandatoryFields = this.getDefaultMandatoryFields();
errorMessages: string[] = [];
showDeactivateButton : boolean = false;
enterReasonMessage: string = DocumentLibraryConstants.DeactivateReason_Message;
@Output() setDocumentDetailsLoader = new EventEmitter<any>();

  constructor(private documentService: DocumentService, private messageService: MessageService) { }

  ngOnInit(): void {
  }

  documentDeactivate(){
  this.display=true;
}

  getDefaultMandatoryFields() {
    return {
      reason: false,
    }
  }
  confirmClick(){
    this.errorMessages=[];
   this.validateCancellationModalControls();
   if(this.errorMessages.length === 0){
    this.setDocumentDetailsLoader.emit(true);
    this.deactivateButton = {
      reason: this.reason,
      phase:9
    }
    this.documentService.moveDocumentToObsoletePhases(this.documentNumber,this.documentVersion,this.deactivateButton)
    .subscribe(
      (serviceData)=>{
        this.display=false;
        this.messageService.add({
          severity: DocumentLibraryConstants.Severity_Info,
          summary: `${DocumentLibraryConstants.DeactivateDocumentVersion_Success}`
        });
        setTimeout(() => {
          this.setDocumentDetailsLoader.emit(false);
          this.isDeactivationModalVisible.emit(true);
          this.display = false;
        }, 3000)
    });
  }
}
validateCancellationModalControls(){
  const isWhitespace = (this.reason || '').trim().length === 0;
  if(this.reason === "" || this.reason === undefined || this.reason?isWhitespace:null){
        this.mandatoryFields.reason = true;
        this.errorMessages.push(DocumentLibraryConstants.MoveToCancelledPhase_Reason_Required); 
  }
}
  cancelClick():void{
    this.display=false;
    this.resetModal();
  }

  resetModal() {
    this.errorMessages = [];
    this.mandatoryFields.reason = false;
    this.reason = '';
  }
  reloadDocumentDetail() {
    this.isDeactivationModalVisible.emit(false);
    this.resetModal();
  }
}
